import { AfterViewInit, Component, OnDestroy, Optional, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import {
  AuthService,
  AuthTokenCheckRequest,
  InlineResponse200,
  IvGenericRestResponseListOrganizationPhonePrefix,
  IvSignService,
  OrganizationService,
  UserService,
} from '../api';
import { AuthPasswordRecoveryRequest } from '../api/model/authPasswordRecoveryRequest';
import { cValidators } from '../models/validator';
import { IvCertGenericResponseOrganizationUserR } from '../api/model/ivCertGenericResponseOrganizationUserR';
import { ProfileComponent } from '../base/profile/profile.component';
import { ColorsService } from '../core/colors/colors.service';
import { ProfileService } from '../core/profile/profile.service';
import { TranslateService } from '../core/translation/translate.service';
import { LoadingService } from '../shared/loading/loading.service';
import { MessageService } from '../shared/message/message.service';
import { Utils } from '../shared/utils/utils';
import { beforeFilter, filter } from '../base/variables/roles-access-list';
import { Title } from '@angular/platform-browser';
import { PersonalizationsService } from '../base/services/personalizations/personalizations.service';
import { Environment } from '../models/environment';
import { IvLoginComponent } from '../shared/components/iv-login/iv-login.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ExtraModel } from '../shared/components/iv-login/models';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LoadingMfaService } from './redirect-mfa/services/redirect-mfa.service';
import { DisplayState } from '../shared/enums/signaturit/signaturit-enums';
import { NotificationService } from '../base/services/notification/notification-service';
import { CertificateService } from '../finish/services/certificate.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [AuthService, OrganizationService, IvSignService, UserService],
})
export class LoginComponent implements AfterViewInit, OnDestroy {
  /**
   * IvLogin component from platform.
   */
  @ViewChild('ivlogin') ivlogin: IvLoginComponent;

  /**
   * IvLogin component from platform.
   */
  @ViewChild('profile') profile: ProfileComponent;

  /**
   * String containing the logo url of Ivcert.
   */
  logoLogin: string = 'assets/images/logo-login.png';

  /**
   * String containing the logo url of Ivcert.
   */
  srcLogoGeneral: string = 'assets/images/logo-login.png';

  /**
   * String containing the logo url of IvSign.
   */
  srcLogoIvSign: string = 'assets/images/logoIvsign.png';

  // Falta la variable errorMessages que se modifica en el commit : 789dda39
  /**
   * Object containing error labels.
   */
  errorMessages = {
    required: '',
    pattern: '',
    email: '',
    password: '',
  };

  /**
   * String that obtains the actual configuration
   */
  profileAccess = null;

  /**
   * Array containing the company id.
   */
  extras: ExtraModel[];

  /**
   * Array containing the welcome messages.
   */
  messages: string[] = [];

  /**
   * Array containing the user charges.
   */
  cargoList = [];

  /**
   * Boolean to hide/show the promotional component
   */
  displayPromo;

  /**
   * Info for the promotional component
   */
  promotional = [];

  /**
   * View SAML button
   */
  viewSAML: boolean;

  /**
   * Only view SAML button
   */
  onlyViewSAML: boolean;

  /**
   * Url that redirects to the external provider
   */
  url: string;

  /**
   * Object to get the config of LocalStorage
   */
  displayBar: string;
  /**
   * Get the info of the promotional component from the environment
   */
  promoContent: any = [];
  /**
   * Obtain the language from cookies
   */
  cookie: any = [];
  /**
   * string that contains the actual id logged
   */
  profileType: string = '';
  /**
   * New area array
   */
  areaArray = [];

  /**
   * Valid base64 string token
   */
  newToken: string;

  destroy$: Subject<boolean> = new Subject<boolean>();

  notifMessage: string = '';

  showErrorMessage: boolean = true;

  transactionId: string = '';

  /**
   * Array containing the login tabs.
   */

  accordionTabs = [
    {
      type: 1,
      fields: [
        {
          id: 'username',
          label: '',
          type: 'text',
          disabled: false,
        },
        {
          id: 'password',
          label: '',
          type: 'password',
          disabled: true,
        },
      ],
      validators: this.fb?.group({ username: ['', Validators.compose([cValidators.required, cValidators.email])] }),
      url: '',
      submitBtnLabel: '',
      title: this._translate?.instant('login_header_tab1'),
      active: true,
      id: 'login_header_tab1',
    },
    {
      type: 3,
      fields: [
        {
          id: 'orgaId',
          label: '',
          type: 'text',
          hidden: false,
          readonly: false,
        },
        {
          id: 'ivsign_username',
          label: '',
          type: 'text',
          disabled: false,
        },
        {
          id: 'ivsign_password',
          label: '',
          type: 'password',
          disabled: false,
        },
      ],
      validators: this.fb?.group({
        orgaId: [],
      }),
      url: '',
      image: this.srcLogoIvSign,
      submitBtnLabel: '',
      samlBtnLabel: '',
      active: true,
      title: '',
      id: 'login_header_tab2',
      onCustomSubmit: (value: any) => {
        const url = window.location.origin + '/login/redirectMFA';
        this._authService
          .mfaTokenPost(
            'password',
            value.ivsign_username,
            value.ivsign_password,
            this.environment?.appid,
            url,
            undefined,
            undefined,
            value.orgaId || undefined
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (response: InlineResponse200) => {
              if (response.urlCallback && response.pretoken && response.transactionId) {
                window.location.href = response.urlCallback;
              }
              this.ivlogin.response(response);
              this.ivlogin.loading = this.ivlogin.btnDisabled = false;
            },
            (error: HttpErrorResponse) => {
              this.showError(error.error);
              this.ivlogin.btnDisabled = false;
            }
          );
      },
      passwordRecover: true,
      recoverBtnLabel: '',
    },
    {
      type: 3,
      fields: [],
      direct: true,
      url: '',
      submitBtnLabel: '',
      title: '',
      active: true,
      id: 'login_header_tab3',
      directFunction: async () => {
        const callbackId = await this._cert.certGate();
        this._authService
          .apiAuthAuthCertPost('password', callbackId)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (response: InlineResponse200) => {
              this.ivlogin.response(response);
              this.ivlogin.loading = this.ivlogin.btnDisabled = false;
            },
            (error: any) => {
              this.showError(error.error);
              this.ivlogin.btnDisabled = false;
            }
          );
      },
    },
    {
      type: 3,
      fields: [],
      url: '',
      submitBtnLabel: this._translate?.instant('login_btn_register'),
      title: this._translate?.instant('login_header_tab4'),
      active: true,
      id: 'login_header_tab4',
      direct: true,
      directFunction: () => {
        if (this.environment?.registerConfig.orga && this.environment?.registerConfig.user) {
          this.router.navigate(['/register/alternative']);
        } else {
          this.router.navigate(['/register']);
        }
      },
    },
  ];
  /**
   * String with the actual language.
   */
  language: string;

  _transParam: boolean = false;

  /**
   * Url obtained from saml
   */
  urlSAML;

  /**
   * Userid
   */
  userSAML: string;

  /**
   * Token
   */
  token: string;

  environment: Environment;

  constructor(
    @Optional()
    private _dialog: MatDialog,
    @Optional()
    public route: ActivatedRoute,
    @Optional()
    public _translate: TranslateService,
    @Optional()
    private router: Router,
    @Optional()
    public fb: FormBuilder,
    @Optional()
    private _authService: AuthService,
    @Optional()
    public _userApi: UserService,
    @Optional()
    private _profile: ProfileService,
    @Optional()
    private _colors: ColorsService,
    @Optional()
    private _loading: LoadingService,
    @Optional()
    private _message: MessageService,
    @Optional()
    public _ivsign: IvSignService,
    @Optional()
    private _organizationApi: OrganizationService,
    @Optional()
    private _title: Title,
    private _personalization: PersonalizationsService,
    private _mfaService: LoadingMfaService,
    private _notification: NotificationService,
    private _cert: CertificateService
  ) {
    this.environment = this._personalization.sendEnv;
    this.extras = [{ nombre: 'appid', valor: this.environment?.appid }];
    this.displayPromo = this.environment?.features.promoContent?.displayPromo;
    this.viewSAML = this.environment?.features.ivsignLoginSAML;
    this.onlyViewSAML = this.environment?.features.onlyLoginSAML;
    this.accordionTabs[0].url = this.environment.url_api;
    this.accordionTabs[0].active = this.environment?.login.options[0];
    this.accordionTabs[1].url = this.environment.url_api;
    this.accordionTabs[1].active = this.environment?.login.options[1];
    this.accordionTabs[1].fields[0].hidden = !this.environment?.login.visibleOrgaID;
    this.accordionTabs[1].fields[0].readonly = this.environment?.features.blockOrgaid;
    const orgaIdForm =
      localStorage.getItem('orgaidform') === null
        ? this.environment?.login.orgaID || ''
        : localStorage.getItem('orgaidform');
    const orgaIdValue = [
      this.environment?.features.orgaIdFinish && this.environment?.features.blockOrgaid
        ? this.environment?.features.orgaIdFinish
        : orgaIdForm,
    ];
    this.accordionTabs[1].validators.get('orgaId').patchValue(orgaIdValue);
    this.accordionTabs[1].passwordRecover = !this.environment?.features.hidePasswordRecover;
    this.accordionTabs[2].url = this.environment.url_api;
    this.accordionTabs[2].active = this.environment?.login.options[2];
    this.accordionTabs[3].url = this.environment.url_api;
    this.accordionTabs[3].active = this.environment?.login.options[3];
    if (this.environment?.login.logo) {
      this.srcLogoGeneral = 'data:image/png;base64,' + this.environment?.login.logo;
    }
    this._title.setTitle('Login - IvCert');
    TranslateService.initTranslateSubscription(this);
  }

  ngOnInit() {
    this.urlSAML = this.router.parseUrl(this.router.url);
    this.token = this.urlSAML.queryParams['token'];
    this.userSAML = this.urlSAML.queryParams['userid'];
    this.transactionId = this.urlSAML.queryParams['transactionid'];
    if (this.userSAML) {
      document.cookie = 'username=' + this.userSAML + ';path=/;';
    }
    if (this.token && !this.transactionId) {
      const sanitized = this.token.trim().replace(/-/g, '+').replace(/_/g, '/').slice(1);
      const paddingNeeded = (4 - (sanitized.length % 4)) % 4;
      this.newToken = 'K' + sanitized + '='.repeat(paddingNeeded);
      this.checkLoginSAML();
    }
    if (
      this.environment?.features.customizationColors?.primary &&
      this.environment?.features.customizationColors?.secondary
    ) {
      this._colors?.setColors(
        this.environment?.features.customizationColors?.primary,
        this.environment?.features.customizationColors?.secondary,
        false
      );
    } else if (this.environment?.features.customizationColors?.primary) {
      this._colors?.setColors(this.environment?.features.customizationColors?.primary, null, false);
    }
    this.showPromo();
  }

  ngAfterViewInit() {
    this.showErrorMessage = this._mfaService.showError;
    if (this.showErrorMessage) {
      this._notification.activeNotif(DisplayState.ERROR);
      this.notifMessage = this._mfaService.notifMessage;
    }
    this._dialog?.closeAll();
    this.ivlogin.onBeforeSubmit?.pipe(takeUntil(this.destroy$)).subscribe((result: any) => {
      this._loading?.set(true);
    });
  }

  ngOnDestroy() {
    this.destroy$.unsubscribe();
  }

  /**
   * Function that translates text strings when starting the component or changing the language.
   */
  translate() {
    this.messages = [
      this._translate?.instant('login_message_morning'),
      this._translate?.instant('login_message_day'),
      this._translate?.instant('login_message_night'),
    ];

    this.accordionTabs[0].fields[0].label = this._translate?.instant('login_label_user');
    this.accordionTabs[0].fields[1].label = this._translate?.instant('login_label_password');
    this.accordionTabs[0].submitBtnLabel = this._translate?.instant('login_btn_submit');
    this.accordionTabs[0].title = this._translate?.instant('login_header_tab1');

    // faltan traducciones this.errorMessages

    this.accordionTabs[1].fields[0].label = this._translate?.instant('login_label_orgaid');
    this.accordionTabs[1].fields[1].label = this._translate?.instant('login_label_user');
    this.accordionTabs[1].fields[2].label = this._translate?.instant('login_label_password');
    this.accordionTabs[1].submitBtnLabel = this._translate?.instant('login_btn_submit');
    this.accordionTabs[1].samlBtnLabel = this._translate?.instant('login_btn_saml');
    this.accordionTabs[1].recoverBtnLabel = this._translate?.instant('link_recover_pass');
    this.accordionTabs[1].title = this._translate?.instant('login_header_tab2');

    this.accordionTabs[2].submitBtnLabel = this._translate?.instant('login_btn_submit');
    this.accordionTabs[2].title = this._translate?.instant('login_header_tab3');

    this.accordionTabs[3].submitBtnLabel = this._translate?.instant('login_btn_register');
    this.accordionTabs[3].title = this._translate?.instant('login_header_tab4');

    this.errorMessages.required = this._translate?.instant('form_error_required');
    this.errorMessages.pattern = this._translate?.instant('form_error_pattern');
    this.errorMessages.email = this._translate?.instant('form_error_email');
    this.errorMessages.password = this._translate?.instant('form_error_password');

    this.validatorCustomText();
    if (this.ivlogin) {
      this.ivlogin?.setTimer();
    }
    this._loading?.set(false);
  }

  /**
   * Function that obtains the user and set it in the form.
   */
  cargarUsuario(user: string) {
    this._userApi.userGetUser(user, this._profile.getToken()).subscribe(
      (response: IvCertGenericResponseOrganizationUserR) => {
        const keys = Object.keys(response.data);
        if (response.data.userIvSign) {
          document.cookie = 'username=' + response.data.userIvSign + ';path=/;';
        }
        if (response.data.idPerfil) {
          document.cookie = 'profileType=' + response.data.idPerfil + ';path=/;';
        }
        for (const key of keys) {
          switch (key) {
            case 'userAreaList':
              for (let index = 0; index < response.data[key].length; index++) {
                if (response.data[key][index].cargoList.length) {
                  this.cargoList.push(response.data[key][index].cargoList);
                }
              }
              sessionStorage.setItem('cargoList', JSON.stringify(this.cargoList));
              break;
          }
        }
        this._loading?.set(false);
      },
      (error: any) => {
        this._loading?.set(false);
        this._message.showError(error);
      }
    );
  }

  /**
   * Function that logins and shows the error or saves the user data and enter to Ivcert.
   * @param {any} response Response from login service.
   */
  async enviamos(response: any) {
    this.profileAccess = response.profileMenu;
    this.profileType = response.idPerfilUser;
    document.cookie = 'profileAccess=' + this.profileAccess + ';path=/;';
    document.cookie = 'profileType=' + this.profileType + ';path=/;';
    document.cookie = 'guidUser=' + response.guidUser + ';path=/;';
    beforeFilter();
    filter();
    if (response.error) {
      this.showError(response.error);
    } else {
      const user: any = Utils.processLogin(response, this.environment.features.sessionExpiration);
      user.email = this.accordionTabs[0].validators.value.username;
      if (response.tokenIvSign != '') {
        const orgaidform = this.accordionTabs[1].validators.value.orgaId;
        if (orgaidform != '') {
          localStorage.setItem('orgaidform', orgaidform);
        }
      }

      const token = 'Bearer ' + user.access_token;
      this._profile?.setUser(user);
      const orgaConfig = {
        idOrganization: response.companyId || null,
        nameOrganization: response.companyName || null,
        cifOrganization: response.OrgaCIF || null,
        logoOrganization: response.OrgaLogo || null,
        colourOrganization: response.OrgaColor || '#0f3e4d',
        typeOrganization: response.OrgaType || null,
        certLabel: response.fieldToUseSIG || null,
      };
      this.cargarUsuario(user.username);
      this.getOrganizationData(orgaConfig, token);
    }
  }

  /**
   * Function that gets the company data.
   * @param {Object} orgaConfig Organization config
   * @param {String} token String that contains the token.
   */
  getOrganizationData(orgaConfig, token: string) {
    this.getPrefixes(token);
    if (orgaConfig) {
      if (orgaConfig.colourOrganization) {
        this._colors?.setColors(orgaConfig.colourOrganization);
      }
      if (orgaConfig.logoOrganization) {
        localStorage.setItem('logo', orgaConfig.logoOrganization);
        this._colors.logo = orgaConfig.logoOrganization;
      }
      localStorage.setItem('orgaConfig', JSON.stringify(orgaConfig));
    }
  }

  /**
   * Function that gets the phone prefixes of the company.
   * @param {String} token String that contains the token.
   */
  getPrefixes(token: string) {
    this._organizationApi
      .organizationGetmobilePhonePrefixes(token)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: IvGenericRestResponseListOrganizationPhonePrefix) => {
          if (response.data) {
            for (let index = 0; index < response.data.length; index++) {
              response.data[index].label = response.data[index].label + ' ' + response.data[index].country;
            }
            localStorage.setItem('prefixes', JSON.stringify(response.data));
          }
          if (localStorage.getItem('pending_logIn')) {
            let url = localStorage.getItem('pending_logIn');
            url = url.slice(1, -1);
            const urlSeparate = url.split('/finishOperation')[1];
            const urlComplete = '/finishOperation' + urlSeparate;
            this.router.navigate([urlComplete]);
          } else {
            const route = this.route.snapshot.queryParams.returnUrl || '/' + this.environment?.login.home || '';
            this.router.navigate([route]);
          }
        },
        (error: any) => {
          if (localStorage.getItem('pending_logIn')) {
            let url = localStorage.getItem('pending_logIn');
            url = url.slice(1, -1);
            const urlSeparate = url.split('/finishOperation')[1];
            const urlComplete = '/finishOperation' + urlSeparate;
            this.router.navigate([urlComplete]);
          } else {
            const route = this.route.snapshot.queryParams.returnUrl || '/' + this.environment?.login.home || '';
            this.router.navigate([route]);
          }
        }
      );

    if (localStorage.getItem('lang') && this.environment.lang && !this.environment.lang.force) {
      this.language = localStorage.getItem('lang');
    } else {
      this.language = this.getLanguage() || 'es';
    }

    const sessionUser = this._profile.getToken();

    if (sessionUser) {
      this._userApi
        .userChangeActiveLanguage(this.language, sessionUser)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response) => {
            this._loading?.set(false);
          },
          (error) => {
            this._loading?.set(false);
            this._message.showError(error);
          }
        );
    }
  }

  /**
   * Function that shows error message.
   * @param {any} error Object that contains the error.
   */
  showError(error: any) {
    const code = error.error;
    let message = '';
    switch (code) {
      case 'IVC1501':
        message = this._translate?.instant('login_error_usuario_contraseña');
        break;
      case 'IVC1502':
        message = this._translate?.instant('login_error_usuario_deshabilitado');
        break;
      case 'invalid_grant':
        message = this._translate?.instant('login_error_usuario_contraseña');
        break;
      default:
        message = this._translate?.instant('login_error_usuario_contraseña');
        break;
    }

    this._loading?.set(false);
    this._message.showError(message, this._translate?.instant('login_error_titulo_usuario_contraseña'));
  }

  recoverPass(event) {
    const orgaId = event.data.orgaId;
    const username = event.data.ivsign_username;
    if (!orgaId || !username) {
      this._message.showError(this._translate?.instant('recover_pass_no_data'));

      return;
    }

    this._loading?.set(true);

    const body: AuthPasswordRecoveryRequest = {
      orgaid: event.data.orgaId[0],
      login: event.data.ivsign_username,
      module: this.environment?.features.module || 'ivcert',
    };

    this._ivsign
      .ivSignPostPasswordRecovery(body, 'token')
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          this._loading?.set(false);
          if (response.error.code === 'K0000') {
            this._message.show(this._translate?.instant('recover_pass_success'), 'success');
          } else {
            this._message.showError(response.error);
          }
        },
        (error: any) => {
          this._message.showError(error);
        }
      );
  }

  private getLanguage(): string {
    const param = document.location.search;
    let active = this.environment.lang?.active ?? ['es'];
    const forced = this.environment.lang?.force ?? null;

    this._translate.activeLanguages = active;

    if (active.length === 1) {
      return active[0];
    }

    const cookieLang = this.getLangFromCookie();
    if (cookieLang) {
      return cookieLang;
    }

    if (forced) {
      return forced;
    }

    const urlLang = this.getLangFromUrl(param, active);
    if (urlLang) {
      return urlLang;
    }

    const browserLang = this.getLangFromBrowser(active);
    if (browserLang) {
      return browserLang;
    }
    return this.environment.lang?.default ?? 'es';
  }

  private getLangFromCookie(): string | null {
    return document.cookie.replace(/(?:(?:^|.*;\s*)lang\s*=\s*([^;]*).*$)|^.*$/, '$1') || null;
  }

  private getLangFromUrl(param: string, active: string[]): string | null {
    const regex = /[?&]lang=([a-z]{2})/i;
    const match = regex.exec(param);
    if (match) {
      const lang = match[1];
      return active.includes(lang) ? lang : null;
    }
    return null;
  }

  private getLangFromBrowser(active: string[]): string | null {
    const idiomas = window.navigator.languages;

    if (Array.isArray(idiomas) && idiomas.length) {
      for (const idioma of idiomas) {
        const lang = idioma.split('-')[0];
        if (active.includes(lang)) {
          return lang;
        }
      }
    }

    const lang = window.navigator.language.split('-')[0];
    return active.includes(lang) ? lang : null;
  }

  showPromo() {
    if (this.displayPromo) {
      this.displayBar = localStorage.getItem('promoLogin');
      if (this.displayBar === 'hide') {
        this.displayPromo = false;
      } else {
        this.displayPromo = true;
      }
    }
    this.customLang();
  }

  customLang() {
    this.promoContent = this.environment?.features.promoContent?.content;
    this.cookie = document.cookie
      .split(';')
      .map((cookie) => cookie.split('='))
      .reduce((accumulator, [key, value]) => ({ ...accumulator, [key.trim()]: decodeURIComponent(value) }), {});

    switch (this.cookie?.lang) {
      case 'es':
        this.promotional = [
          {
            img: this.promoContent?.img_es,
            text: this.promoContent?.text_es,
            linkText: this.promoContent?.linkText_es,
            link: this.promoContent?.link,
          },
        ];
        break;
      case 'en':
        this.promotional = [
          {
            img: this.promoContent?.img_en,
            text: this.promoContent?.text_en,
            linkText: this.promoContent?.linkText_en,
            link: this.promoContent?.link,
          },
        ];
        break;
      case 'fr':
        this.promotional = [
          {
            img: this.promoContent?.img_fr,
            text: this.promoContent?.text_fr,
            linkText: this.promoContent?.linkText_fr,
            link: this.promoContent?.link,
          },
        ];
        break;
      case 'ca':
        this.promotional = [
          {
            img: this.promoContent?.img_ca,
            text: this.promoContent?.text_ca,
            linkText: this.promoContent?.linkText_ca,
            link: this.promoContent?.link,
          },
        ];
        break;
      case 'pt':
        this.promotional = [
          {
            img: this.promoContent?.img_po,
            text: this.promoContent?.text_po,
            linkText: this.promoContent?.linkText_po,
            link: this.promoContent?.link,
          },
        ];
        break;
      default:
        this.promotional = [
          {
            img: this.promoContent?.img_es,
            text: this.promoContent?.text_es,
            linkText: this.promoContent?.linkText_es,
            link: this.promoContent?.link,
          },
        ];
        break;
    }
  }

  /**
   * Function redirect to external provider
   */
  redirectSAML(event) {
    const companyName = this.environment?.login.orgaID;
    if (companyName) {
      this._ivsign
        .ivSignPostLoginSAML(companyName)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response) => {
            this.url = response.url;
            window.location.replace(this.url);
          },
          (error: any) => {
            this._message.showError(error);
          }
        );
    } else {
      this._message.showError(this._translate.instant('saml_error_configuracion'));
    }
  }

  /**
   * Function that checks if there's an IvSign token.
   */
  checkLoginSAML() {
    if (this.newToken) {
      const authObject: AuthTokenCheckRequest = {
        token: this.newToken,
      };
      this._ivsign
        .ivSignPostTokenCheck(authObject)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response) => {
            if (response.error.code !== 'K0010') {
              if (!response.result) {
                this._profile.removeUserProperty('tokenIvSign');
              } else {
                const bearerToken = 'Bearer ' + this.newToken;
                this._userApi
                  .userGetCheckUserId(this.userSAML, bearerToken)
                  .pipe(takeUntil(this.destroy$))
                  .subscribe(
                    (response) => {
                      if (response) {
                        this._userApi.userGetUserIvSignById(this.userSAML, bearerToken).subscribe((res) => {
                          const date = new Date();
                          document.cookie = 'guidUser=' + res.data.guidUser + ';path=/;';
                          const session = this.environment?.features?.sessionExpiration;
                          if (session !== undefined) {
                            date.setTime(date.getTime() + session);
                          } else {
                            date.setTime(date.getTime() + 5400000);
                          }
                          for (let i = 0; i < res.data.userAreaList.length; i++) {
                            const object = {
                              idArea: res.data.userAreaList[i].idArea,
                              idRol: res.data.userAreaList[i].idRole,
                            };
                            this.areaArray.push(object);
                          }
                          const data = {
                            expires: date.toUTCString(),
                            access_token: this.newToken,
                            companyId: res.data.idCompany,
                            companyName: res.data.nameCompany,
                            guidUser: res.data.guidUser,
                            idPerfilUser: res.data.idPerfil,
                            idUser: res.data.idUser,
                            name: res.data.name,
                            qualifiedUser: res.data.qualifiedUser,
                            refresh_token: '',
                            rol: JSON.stringify(this.areaArray),
                            tokenIvSign: this.newToken,
                            token_type: 'bearer',
                          };
                          const user: any = Utils.processLogin(data, this.environment.features.sessionExpiration);
                          user.email = res.data.email;
                          const token = 'Bearer ' + this.newToken;
                          this._profile.setUser(user);
                          document.cookie = 'profileType=' + res.data.idPerfil + ';path=/;';
                          this.cargarUsuario(user.username);
                          if (this.userSAML) {
                            this.getMenuConfigSAML(() => this.getOrganizationData(data, token));
                          } else {
                            this.getOrganizationData(data, token);
                          }
                        });
                      }
                    },
                    (error: any) => {
                      this._message.showError(error);
                    }
                  );
              }
            } else {
              this._message.showError({ message: response.error.message });
            }
          },
          (error) => {
            this._message.showError(error);
          }
        );
    }
  }

  getMenuConfigSAML(callback?: () => void): void {
    this._userApi.userGetUserProfile(this._profile.getToken()).subscribe(
      (response) => {
        if (response.data) document.cookie = 'profileAccess=' + response.data + ';path=/;';
        callback?.();
      },
      (error) => {
        this._message.showError(error);
        callback?.();
      }
    );
  }

  validatorCustomText() {
    if (this.environment.features.labelLoginIvSign) {
      this.accordionTabs[1].title = this.environment.features.labelLoginIvSign;
    }
    if (this.environment.features.labelButtonSAML) {
      this.accordionTabs[1].samlBtnLabel = this.environment.features.labelButtonSAML;
    }
  }
}
